import {
    Breadcrumbs,
    Grid,
    Typography
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { ArrowBack } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';
import { LinkProps, Link as RouterLink } from 'react-router-dom';

import muiStyles from './styles';
import { BackButtonProps } from './types';

const Link = (RouterLink as unknown) as React.ComponentClass<LinkProps>;

export default function BackButton(props: BackButtonProps) {
    const {
        className,
        links
    } = props;
    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    const renderLinks = () => {
        if (Array.isArray(links)) {
            return (
                <Breadcrumbs
                    aria-label='breadcrumb'
                    className={classes.breadcrumbContainer}
                >
                    {links.map(({ to, text, handleNavigation }) => {
                        if (handleNavigation) {
                            return (
                                <Link
                                    className={classes.link}
                                    key={`breadcrumb_${to}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleNavigation(to);
                                    }}
                                    to=''
                                >
                                    <Typography
                                        className={classes.anchorText}
                                        variant='h5'
                                    >
                                        {text}
                                    </Typography>
                                </Link>
                            );
                        }

                        return (
                            <Link
                                className={classes.link}
                                key={`breadcrumb_${to}`}
                                to={to}
                            >
                                <Typography
                                    className={classes.anchorText}
                                    variant='h5'
                                >
                                    {text}
                                </Typography>
                            </Link>
                        );
                    })}
                </Breadcrumbs>
            );
        }

        if (typeof links.handleNavigation === 'function') {
            return (
                <Link
                    className={`${classes.singleLink} ${classes.link}`}
                    onClick={(e) => {
                        e.preventDefault();
                        if (typeof links.handleNavigation === 'function') {
                            links.handleNavigation(links.to);
                        }
                    }}
                    to=''
                >
                    <Typography
                        className={`title ${classes.anchorText}`}
                        variant='h5'
                    >
                        {links.text}
                    </Typography>
                </Link>
            );
        }

        return (
            <Link
                className={`${classes.singleLink} ${classes.link}`}
                to={links.to}
            >
                <Typography
                    className={`title ${classes.anchorText}`}
                    variant='h5'
                >
                    {links.text}
                </Typography>
            </Link>
        );
    };

    return (
        <Grid
            alignItems='center'
            className={`${className} ${classes.root}`}
            container
            direction='row'
            spacing={0}
        >
            <Link
                className={classes.backArrow}
                to={Array.isArray(links) ? (links[links.length - 1] || {}).to : links.to}
            >
                <ArrowBack
                    className={classes.backArrow}
                    iconColor={theme?.app?.clientTheme.colors.primaryColor || '#375073'}
                />
            </Link>
            {renderLinks()}
        </Grid>
    );
}